export const ipAddressRegex = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/;
export const urlRegex =
  /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;

/**
 * Test a string against an array of regular expressions.
 * Returns true only if the string matches all regex patterns.
 *
 * @param input - The string to test.
 * @param regexes - An array of RegExp objects to validate against.
 * @returns boolean - True if all regex tests succeed, false otherwise.
 */
export function testAllRegex(input: string, regexes: RegExp[]): boolean {
  return regexes.every((regex) => regex.test(input));
}
